import { FC } from 'react';
import { theme } from 'antd';
import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const CompAirAssurePlanPlusIcon: FC<{
  width?: number;
  height?: number;
  [x: string]: unknown;
}> = ({ width = 104, height = 32, ...rest }) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };

  const primaryColor = token.CompairAssure.colorPrimary;
  const secondaryColor = token.CompairAssure.colorSecondary;

  return (
    <svg width={width} height={height} viewBox="0 0 104 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M98.6274 12.3734C98.6274 13.1793 98.1148 13.7287 97.3819 13.7287C96.649 13.7287 96.0982 13.1427 96.0982 12.3734V8.78396H92.5102C91.7031 8.78396 91.1546 8.27121 91.1546 7.53883C91.1546 6.80623 91.7391 6.25684 92.5102 6.25684H96.0982V2.66758C96.0982 1.89834 96.649 1.31231 97.3819 1.31231C98.1148 1.31231 98.6274 1.8617 98.6274 2.66758V6.25684H102.215C102.986 6.25684 103.571 6.80623 103.571 7.53883C103.571 8.27121 103.022 8.78396 102.215 8.78396H98.6274V12.3734Z"
        fill="#00A650"
      />
      <path
        d="M63.3322 15.588H64.1641C65.5004 15.588 66.2132 14.9642 66.2132 13.8654C66.2132 12.7516 65.5302 12.113 64.2826 12.113H63.3322V15.588ZM64.3568 10.6577C67.0003 10.6577 68.2924 11.6675 68.2924 13.8654C68.2924 15.8406 66.926 17.0431 64.4311 17.0431H63.3322V20.9637H61.2979V10.6577H64.3568Z"
        fill="#00A650"
      />
      <path d="M70.8502 10.6577V19.3896H74.9785V20.9637H68.816V10.6577H70.8502Z" fill="#00A650" />
      <path
        d="M77.8146 17.0136H81.2006L79.5372 12.3803L77.8146 17.0136ZM80.7998 10.6577L84.7796 20.9637H82.5964L81.7351 18.5282H77.2503L76.3592 20.9637H74.3398L78.3491 10.6577H80.7998Z"
        fill="#00A650"
      />
      <path
        d="M87.2631 10.6577L91.0499 17.8602C91.2282 18.2165 91.4659 18.8403 91.7329 19.7313C91.5549 18.6768 91.4804 17.8897 91.4804 17.3699V10.6577H93.322V20.9637H90.8124L86.9066 13.5981C86.7136 13.2416 86.5058 12.6478 86.298 11.816C86.4761 13.1524 86.5503 13.9694 86.5503 14.2812V20.9637H84.7089V10.6577H87.2631Z"
        fill="#00A650"
      />
      <path
        d="M24.2048 23.2442C21.9876 26.8148 18.8315 29.606 14.5862 31.7543L14.1007 32L13.6148 31.7556C9.10171 29.4868 5.81643 26.4575 3.57122 22.4948C0.834195 17.6641 -0.310409 11.5904 0.0715481 3.92689L0.112487 3.10601L14.0962 0L28.078 3.1055L28.1208 3.9246C28.197 5.39216 28.2174 6.80225 28.181 8.15512C28.1726 8.15512 26.037 8.15487 26.0162 8.15487C26.0485 7.10588 26.0459 6.00604 26.0032 4.85432L14.0962 2.20935L2.19113 4.85381C1.6299 20.8724 8.54836 26.6701 14.0977 29.5791C16.5888 28.2651 19.3568 26.367 21.5987 23.244L24.2048 23.2442Z"
        fill="#0E88D3"
      />
      <path
        d="M14.0969 4.00342L3.83141 6.28373C3.64043 10.1175 3.96263 13.3156 4.66627 16C6.28819 22.1861 9.9473 25.6262 14.0992 27.7135V4.00393L14.0969 4.00342Z"
        fill={primaryColor}
      />
      <path
        d="M27.276 12.935C26.3824 12.4679 25.4888 12.2242 24.6155 12.2242C23.6405 12.2242 23.1327 12.5693 23.1327 13.1583C23.1327 13.9097 23.8844 14.174 25.0216 14.6818C26.9512 15.5347 27.926 16.3065 27.926 17.8702C27.926 19.7795 26.3216 21.0589 23.5594 21.0589C22.8179 21.0589 22.2966 20.9574 21.685 20.7351L20.8893 18.6718C21.8843 19.1592 22.5437 19.2312 23.5391 19.2312C24.6155 19.2312 25.1841 18.8452 25.1841 18.2359C25.1841 17.4638 24.392 17.0783 23.0923 16.4283C21.4472 15.6158 20.4926 14.9254 20.4926 13.4632C20.4926 11.7368 22.0565 10.3963 24.6562 10.3963C25.5495 10.3963 26.5042 10.6806 27.4792 10.9853L27.276 12.935Z"
        fill={primaryColor}
      />
      <path
        d="M34.4729 12.935C33.5793 12.4679 32.6857 12.2242 31.8122 12.2242C30.8374 12.2242 30.3298 12.5693 30.3298 13.1583C30.3298 13.9097 31.081 14.174 32.2185 14.6818C34.1479 15.5347 35.1229 16.3065 35.1229 17.8702C35.1229 19.7795 33.5182 21.0589 30.7563 21.0589C29.6188 21.0589 28.5223 20.876 27.5674 20.5309L27.7098 18.4998C28.7049 18.9873 29.7409 19.2312 30.7357 19.2312C31.8122 19.2312 32.381 18.8452 32.381 18.2359C32.381 17.4638 31.5889 17.0783 30.2892 16.4283C28.6438 15.6158 27.6895 14.9254 27.6895 13.4632C27.6895 11.7368 29.2534 10.3963 31.8528 10.3963C32.7467 10.3963 33.7011 10.6806 34.6761 10.9853L34.4729 12.935Z"
        fill={primaryColor}
      />
      <path
        d="M37.9508 10.6603V16.1236C37.9508 18.0126 38.5804 18.9059 39.9816 18.9059C41.5254 18.9059 42.3987 17.667 42.3987 15.2504V10.6603H45.0594V20.9573H42.6423V18.9873C41.8705 20.3885 40.6112 21.1196 38.9865 21.1196C36.59 21.1196 35.2903 19.6169 35.2903 16.6922V10.6603H37.9508Z"
        fill={primaryColor}
      />
      <path
        d="M51.9565 12.8943C51.6513 12.7928 51.3469 12.7522 51.0423 12.7522C49.3161 12.7522 48.3615 13.9097 48.3615 16.144V20.9574H45.7211V10.6603H48.0975V12.7117C48.7475 11.1882 49.7629 10.4167 51.1438 10.4167C51.4077 10.4167 51.7126 10.4571 52.0577 10.5181L51.9565 12.8943Z"
        fill={primaryColor}
      />
      <path
        d="M56.0457 12.1224C54.705 12.1224 53.7504 13.1178 53.5474 14.8846H58.4012C58.2593 13.1178 57.3657 12.1224 56.0457 12.1224ZM60.798 16.5297H53.5474C53.6896 18.2561 54.9489 19.3326 56.9189 19.3326C57.9753 19.3326 58.9907 19.0887 59.9451 18.5811V20.612C58.9907 20.998 57.8329 21.2213 56.4515 21.2213C53.0192 21.2213 50.9683 19.1294 50.9683 15.6361C50.9683 12.5085 53.0396 10.3963 56.066 10.3963C59.0512 10.3963 60.798 12.346 60.798 15.6971V16.5297Z"
        fill={primaryColor}
      />
      <path
        d="M11.7388 15.555H16.3693L14.0946 9.21841L11.7388 15.555ZM15.8211 6.86259L21.2641 20.9574H18.2786L17.1004 17.6266H10.967L9.74839 20.9574H6.98621L12.4699 6.86259H15.8211Z"
        fill={primaryColor}
      />
      <path
        d="M11.7365 15.555H14.09L14.0923 9.21841L11.7365 15.555ZM14.09 17.6266H10.9647L9.74607 20.9574H6.98413L12.4676 6.86259H14.09"
        fill={secondaryColor}
      />
    </svg>
  );
};

export default CompAirAssurePlanPlusIcon;
